import { render } from "./transaction-details.vue?vue&type=template&id=25c74b64&scoped=true"
import script from "./transaction-details.vue?vue&type=script&lang=js"
export * from "./transaction-details.vue?vue&type=script&lang=js"

import "./transaction-details.vue?vue&type=style&index=0&id=25c74b64&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c74b64"]])

export default __exports__